var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"side-drawer--intended",attrs:{"fluid":"","pa-0":""}},[_c('div',{staticClass:"pa-5 pb-1 mt-5"},[_vm._t("header")],2),_c('div',{staticClass:"elevation-8 ml-3 pa-5 white flex-fill"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }